import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import PreviewProducts from "../components/preview_products";
import { selectDefaultReducer } from "../redux/default/selectors";

const PreviewProductsContainer = () => {
  const dispatch = useDispatch();

  const { 
    products, 
    previewActive, 
    previewKey 
  } = useSelector(selectDefaultReducer);

  const previewPhotoSources = products
    .map(p => p.previewPhotoUrl)
    .filter(url => url !== "" && url !== undefined);

  const activatePreview = () => dispatch(Action.activatePreview());
  const hidePreview = () => dispatch(Action.hidePreview());

  return (
    <PreviewProducts
      previewActive={previewActive}
      previewKey={previewKey}
      previewPhotoSources={previewPhotoSources}
      activatePreview={activatePreview}
      hidePreview={hidePreview}
    />
  );
};

export default PreviewProductsContainer;